// Accessible keyboard navigation of link groups, jump from one heading to the next with keyboard keys
let linkGroups = document.querySelectorAll('.linkGroup');
linkGroups.forEach((group) => {
    group.addEventListener('keyup',
        (event) => {
            let trigger = event.target;
            const headingClass = 'linkGroup-heading';
            if (event.defaultPrevented ||
                !(trigger.classList.contains(headingClass) || trigger.parentNode.classList.contains(headingClass))) {
                return;
            }
            var nextFocus = null;

            switch (event.key) {
                case 'ArrowDown':
                case 'Down':
                    event.preventDefault();
                    if (event.currentTarget.nextElementSibling) {
                        nextFocus = event.currentTarget.nextElementSibling.querySelector(`.${headingClass}`).children[0];
                    }
                    break;
                case 'ArrowUp':
                case 'Up':
                    event.preventDefault();
                    if (event.currentTarget.previousElementSibling) {
                        nextFocus = event.currentTarget.previousElementSibling.querySelector(`.${headingClass}`).children[0];

                    }
                    break;
            }

            if (nextFocus) {
                nextFocus.focus();
            }

        });
});